import { apiRequest } from '../../../../../../shared/services/api/apiRequest';
import { getTrackingMetadata } from '../getTrackingMetadata';

export interface VideoRoomHeartbeatResponse {
  message: string;
  room_id: number;
  last_heartbeat: string | null;
  cc_status: 'on' | 'off';
}

export const sendVideoRoomHeartbeat = async (roomId: number, meetingId: string, userName: string, user: { id: number } | null): Promise<VideoRoomHeartbeatResponse> => {
  const timestamp = Math.floor(Date.now() / 1000);
  const heartbeatKey = `${meetingId}_${userName}_${timestamp}`;
  
  // Get tracking metadata
  const trackingMetadata = getTrackingMetadata(user);
  
  // Include tracking metadata in the request
  const requestWithMetadata = {
    heartbeat_key: heartbeatKey,
    ...trackingMetadata,
  };
  
  return apiRequest('/api/video-room/heartbeat/', 'POST', requestWithMetadata);
};



export interface VideoRoomActiveUser {
  user_id: number;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  joined_at: string | null;
  last_heartbeat: string | null;
  is_creator: boolean;
}

export interface VideoRoomActiveUsersResponse {
  room_id: number;
  active_users: VideoRoomActiveUser[];
  active_count: number;
}

export const getVideoRoomActiveUsers = async (roomId: number): Promise<VideoRoomActiveUsersResponse> => {
  return apiRequest(`/api/video-room/active-users/?room_id=${roomId}`, 'GET');
}; 